import { createSelector } from 'reselect';

import { getSystem } from './system.selectors';

const getDocumentTypeAliases = createSelector(
  getSystem,
  ({ documentTypeAliases }) => documentTypeAliases,
);

export const getDocumentTypeAliasesValues = createSelector(getDocumentTypeAliases, aliases =>
  Object.values(aliases),
);

export const selectDeprecatedDocumentTypeIds = createSelector(
  getDocumentTypeAliasesValues,
  aliases => new Set(aliases.map(({ deprecatedDocumentTypeId }) => deprecatedDocumentTypeId)),
);
